<template>
  <a-modal title="选择成绩" v-model="visible" @ok="onSubmit" :confirmLoading="confirmLoading" width="1200px" @cancel="closeModal(true)">
    <div>
      <a-form class="grade-search-form">
        <a-row :gutter="12">
          <a-col :span="6">
            <a-form-item label="考试名称">
              <a-input placeholder="请输入考试名称" v-model="searchForm.examName" :maxLength="30" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="学期">
              <a-select v-model="searchForm.term" placeholder="请选择考试学期" allowClear>
                <a-select-option :value="1"> 上学期 </a-select-option>
                <a-select-option :value="2"> 下学期 </a-select-option>
                <a-select-option :value="0"> 其他 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="考试类型">
              <a-select v-model="searchForm.type" placeholder="请选择考试类型" allowClear>
                <a-select-option :value="0"> 普通小考 </a-select-option>
                <a-select-option :value="1"> 期末考试</a-select-option>
                <a-select-option :value="2"> 期中考试 </a-select-option>
                <a-select-option :value="3"> 中高考模拟考 </a-select-option>
                <a-select-option :value="4"> 开学摸底考 </a-select-option>
                <a-select-option :value="5"> 分班考试 </a-select-option>
                <a-select-option :value="6"> 区域统考 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="考试时间">
              <a-range-picker v-model="searchForm.examTime" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="负责人">
              <a-select show-search :filter-option="filterOption" allowClear v-model="searchForm.operatorId" placeholder="请选择负责人">
                <a-select-option :value="item.adminId" v-for="item in adminList" :key="item.id">
                  {{ item.adminName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item>
              <a-button type="primary" @click="getList(1)">查询</a-button>
              <a-button style="margin-left: 16px" @click="handleReset">重置</a-button>
              <a-button type="primary" style="margin-left: 16px" @click="onUploadGrade">上传成绩</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        :row-selection="rowSelection"
        :columns="columns"
        :key="Date.now()"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        class="grade-table"
      >
        <div slot="type" slot-scope="record">
          {{
            record.type === 0
              ? '普通小考'
              : record.type === 1
              ? '期末考试'
              : record.type === 2
              ? '期中考试'
              : record.type === 3
              ? '中高考模拟考'
              : record.type === 4
              ? '开学摸底考'
              : record.type === 5
              ? '分班考试'
              : record.type === 6
              ? '区域统考'
              : '其他'
          }}
        </div>
        <div slot="term" slot-scope="record">
          {{ record.term === 1 ? '上学期' : record.term === 2 ? '下学期' : '其他' }}
        </div>
        <div slot="remark" slot-scope="record">
          <a-tooltip>
            <template slot="title"> {{ record.remark }}</template>
            <div class="remark">
              {{ record.remark || '--' }}
            </div>
          </a-tooltip>
        </div>
        <div slot="examTime" slot-scope="record">
          <div class="remark">
            {{ record.examTime.split(' ')[0] }}
          </div>
        </div>
        <div slot="action" class="action" slot-scope="text, record">
          <a-button type="link" :loading="text.downLoadLoading" v-if="isDownLoad || user.id === record.operatorId" icon="download" @click="onDownload(text)"> 下载数据 </a-button>
        </div>
      </a-table>
      <uploadGrade ref="uploadGradeRef" />
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'
import { arrayToXlsx } from '@/utils/util'
import uploadGrade from '../components/uploadGrade.vue'
import { mapState } from 'vuex'

const columns = [
  {
    dataIndex: 'examName',
    title: '考试名称',
    width:220,
    ellipsis: true,
  },
  {
    scopedSlots: { customRender: 'term' },
    title: '学期',
  },
  {
    scopedSlots: { customRender: 'type' },
    title: '考试类型',
  },
  {
    dataIndex: 'operatorName',
    title: '负责人',
  },
  {
    title: '考试时间',
    scopedSlots: { customRender: 'examTime' },
  },
  {
    scopedSlots: { customRender: 'action' },
    title: '操作',
  },
]

export default {
  name: 'SelectGrade',
  components: { uploadGrade },
  data() {
    return {
      searchForm: {
        examName: undefined,
        term: undefined,
        type: undefined,
        examTime: undefined,
        operatorId: undefined,
      },
      confirmLoading: false,
      tableRelevant: tableRelevant.call(this, this.getList),
      visible: false,
      options: {},
      adminList: [],
      columns,
      selectedKeys: [],
    }
  },
  computed: {
    ...mapState('account', ['user']),
    isDownLoad() {
      return this.$auth((_, __, permissions) => permissions.some((item) => item.operation && item.operation.indexOf('grade.download') !== -1))
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedKeys,
        onSelect: (selected) => {
          this.selectedKeys = [selected.id]
        },
      }
    },
  },
  methods: {
    async getList(reset) {
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        organizationId: this.options.organizationId,
      }
      if (params.examTime) {
        params.examTime = params.examTime?.map((item) => moment(item).format('YYYY-MM-DD'))
        params.startTime = params.examTime?.[0]
        params.endTime = params.examTime?.[1]
      }
      delete params.examTime
      this.tableRelevant.tableLoading = true
      const { data } = await this.$http.ReportService.getGradeExam(params).finally(() => (this.tableRelevant.tableLoading = false))
      this.tableRelevant.tableDataSource = data.items
      this.tableRelevant.tablePagination.total = data.totalCount
      this.tableRelevant.tablePagination.current = data.pageIndex
    },
    showModal(options) {
      return new Promise((resolve, reject) => {
        this.options = options
        this.getList(1)
        this.getAdminList()
        this.visible = true
        this._reject = reject
        this._resolve = resolve
      })
    },
    closeModal(reject, parmas) {
      reject ? this._reject(parmas) : this._resolve(parmas)
      this.visible = false
      this.selectedKeys = []
    },
    async onSubmit() {
      if (this.selectedKeys.length === 0) {
        this.$message.error('请选择成绩')
        return
      }
      const params = {
        groupReportId: this.options.groupReportId,
        examId: this.selectedKeys[0],
      }
      const { data, isSuccess, message } = await this.$http.ReportService.chooseReportExam(params, { message: false }).catch((err) => err)
      if (!isSuccess) {
        return this.closeModal(true, { message: message, errorData: data, examId: this.selectedKeys[0], exam: this.tableRelevant.tableDataSource.find((item) => this.selectedKeys[0] == item.id) })
      }
      this.closeModal(false, { data, isSuccess, message })
    },
    async onDownload(record) {
      try {
        const params = {
          id: record.id,
        }
        this.$set(record, 'downLoadLoading', true)
        const { data } = await this.$http.ReportService.downloadGradeExam(params)
        if (!data.length) return
        const columns = [
          '学校名称',
          '学生id',
          '姓名',
          '性别',
          '出生日期',
          '年级',
          '班级',
          '语文成绩（必填）',
          '数学成绩（必填）',
          '英语成绩（必填）',
          '物理成绩',
          '化学成绩',
          '生物成绩',
          '政治成绩',
          '历史成绩',
          '地理成绩',
        ]
        const exportKeys = [
          'organziationName',
          'organizationUserId',
          'realName',
          'gender',
          'birthday',
          'gradeName',
          'className',
          'chineseScore',
          'mathScore',
          'englishScore',
          'physicsScore',
          'chemistryScore',
          'biologyScore',
          'politicsScore',
          'historyScore',
          'geographyScore',
        ]
        const exportData = []
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const reulst = []
          exportKeys.forEach((key) => {
            let val = Array.isArray(item[key]) ? item[key].join('，') : item[key]
            if (key == 'gender') {
              val = val == 1 ? '男' : '女'
            }
            if (key == 'organziationName') {
              val = record.organziationName
            }
            if (key == 'birthday') {
              val = moment(val).format('YYYY-MM-DD')
            }
            reulst.push(String(val ?? ''))
          })
          exportData.push(reulst)
        }
        arrayToXlsx(exportData, {
          columns,
          fileName: record.examName + '成绩.xlsx',
          generate: (obj) => {
            obj.aoa['!cols'] = Array.from({ length: columns.length }, (_, i) => (i + 1 === columns.length ? { wpx: 140 } : { wpx: 100 }))
          },
        })
      } finally {
        this.$set(record, 'downLoadLoading', false)
      }
    },
    handleReset() {
      this.searchForm = {
        examName: undefined,
        term: undefined,
        type: undefined,
        examTime: undefined,
        operatorId: undefined,
      }
      this.getList(1)
    },
    getAdminList() {
      this.$http.Mechanism.GetOrganizationAdmin().then((res) => {
        this.adminList = res.data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async onUploadGrade() {
      const options = {
        organizationId: this.options.organizationId,
      }
      await this.$refs['uploadGradeRef'].showModal(options)
      this.getList()
    },
  },
}
</script>

<style scoped>
.grade-search-form .ant-form-item {
  display: flex;
}

.grade-search-form ::v-deep .ant-form-item-control-wrapper {
  flex: 1;
}
.grade-table ::v-deep .ant-table-thead .ant-table-selection-column .ant-checkbox-wrapper {
  display: none;
}
.remark {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
